var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { FormatMetadata } from "../Metadata";
import prioritySortingCriteria from "../utils/prioritySortingCriteria";

import { FeatureToggle } from "../components/Elements/FeatureToggle";
import { FavoriteBanner } from "../Favorites";
import helpers from "../Documents/helpers";
import { Translate } from "../I18N";
import { RowList, ItemFooter } from "./Lists";
import DocumentLanguage from "./DocumentLanguage";
import Icon from "./Icon";
import Tip from "./Tip";
import ItemSnippet from "./ItemSnippet";
import TemplateLabel from "./TemplateLabel";

export class Item extends Component {
  getSearchSnipett(doc) {
    if (!doc.snippets || !doc.snippets.count) {
      return false;
    }
    return /*#__PURE__*/(
      _jsx(ItemSnippet, { onSnippetClick: this.props.onSnippetClick, snippets: doc.snippets, doc: doc }));

  }

  render() {
    const { onClick, onMouseEnter, onMouseLeave, active, additionalIcon, additionalText, buttons } =
    this.props;

    const doc = helpers.performantDocToJSWithoutRelations(this.props.doc);
    const Snippet = additionalText ? /*#__PURE__*/
    _jsx("div", { className: "item-snippet-wrapper" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "item-snippet" }, void 0, additionalText)
    ) :
    null;
    const baseClasName = `item-document template-${doc.template}`;
    const itemClassName = `${baseClasName} ${this.props.className || ''}`;
    const itemProps = {
      className: itemClassName,
      onClick,
      onMouseEnter,
      onMouseLeave,
      active,
      tabIndex: '1'
    };

    return /*#__PURE__*/(
      React.createElement(RowList.Item, itemProps,
      this.props.itemHeader, /*#__PURE__*/
      _jsx("div", { className: "item-info" }, void 0, /*#__PURE__*/
      _jsx("h2", { className: "item-name" }, void 0,
      additionalIcon || '', /*#__PURE__*/
      _jsx(Icon, { className: "item-icon item-icon-center", data: doc.icon }), /*#__PURE__*/
      _jsx("span", {}, void 0, doc[this.props.titleProperty]), /*#__PURE__*/
      _jsx(DocumentLanguage, { doc: this.props.doc })
      ),
      Snippet,
      this.getSearchSnipett(doc)
      ), /*#__PURE__*/
      _jsx("div", { className: "item-metadata" }, void 0, /*#__PURE__*/
      _jsx(FormatMetadata, {
        entity: this.props.noMetadata ? {} : doc,
        sortedProperty: this.props.search.sort,
        additionalMetadata: this.props.additionalMetadata }
      )
      ), /*#__PURE__*/
      _jsx(ItemFooter, {}, void 0, /*#__PURE__*/
      React.createElement(React.Fragment, null,
      doc.template ? /*#__PURE__*/_jsx(TemplateLabel, { template: doc.template }) : false,
      doc.published ?
      '' : /*#__PURE__*/

      _jsx(Tip, { icon: "lock" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This entity is restricted from public view.")
      )

      ),
      this.props.labels,
      buttons
      ), /*#__PURE__*/
      _jsx(FeatureToggle, { feature: "favorites" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-favorite" }, void 0, /*#__PURE__*/
      _jsx(FavoriteBanner, { sharedId: doc.sharedId })
      )
      )
      ));

  }
}

Item.defaultProps = {
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  noMetadata: false
};























Item.defaultProps = {
  search: prioritySortingCriteria.get(),
  titleProperty: 'title'
};

export const mapStateToProps = ({ templates, thesauris }, ownProps) => {
  const search = ownProps.searchParams;
  const _templates = ownProps.templates || templates;
  return { templates: _templates, thesauris, search };
};

export default connect(mapStateToProps)(Item);